export default {
  middleware_url: "https://wip.esmal.fluid-it.fr",
  cake_url: "https://wip.cake.esmal.fluid-it.fr",
  isWavesoftEnabled: false,
  isUrbantzEnabled: true,
  showLockBillingButton: true,
};
